export default __webpack_public_path__ + "static/media/mail_resume.d8d64b09.svg";